import React from "react";
import { CustomTooltip } from "./DashboardCustomTooltipStyle";

const DashboardCustomTooltip = ({ active, payload, label }) => {
  function changeDateFormat(date) {
    const year = date.split("-")[0];
    const month = date.split("-")[1];
    const day = date.split("-")[2];

    return `${year}년 ${month}월 ${day}일`;
  }

  function avgPriceFormat(avgPrice) {
    return `${avgPrice.toLocaleString("ko-KR")}원`;
  }

  if (active && payload) {
    return (
      <CustomTooltip className="custom-tooltip">
        <p className="label">{changeDateFormat(label)}</p>
        <p className="intro">{avgPriceFormat(payload[0].value)}</p>
      </CustomTooltip>
    );
  }
};

export default DashboardCustomTooltip;
